// GameCard.jsx
import React, { useState, useEffect } from 'react';
import styles from './VipCard.module.css';

const images = [
    './vip-bg-1.png',
    '/vip-bg-2.png',
    '/vip-bg-3.png',
    '/vip-bg-4.png',
];

const badges = [
    './vip-badge-1.png',
    './vip-badge-2.png',
    './vip-badge-3.png',
    './vip-badge-4.png',
]

const VipCard = ({ t, index, p, eligible, isActive }) => {
    return (
        <div
            key={t._id}
            className={`relative p-4 rounded-lg overflow-hidden flex items-center justify-between ${styles.cardContainer} ${styles.cardBackground}`}
        >
            {/* Left Content */}
            <div className="relative z-10 w-[70%] text-white">
                <div className="font-bold text-2xl mb-3 flex items-center">
                    {t.name}
                    {/* Faction/Badge Icon */}
                    <div className="w-9 h-9 ml-2 bg-contain bg-center bg-no-repeat" style={{ backgroundImage: `url(${badges[index % badges.length]})` }}></div>
                </div>

                <div className="text-sm">
                    {/* Rephrased text for gamified look */}
                    <div className="mb-1">
                        <span className="font-semibold text-teal-300">QUEST:</span> Unlock {t.unlockOrders} orders in {t.unlockWindowDays} days
                    </div>
                    <div className="mb-1">
                        <span className="font-semibold text-teal-300">STATUS:</span> Active for {t.freeValidityDays} days (Free Trial)
                    </div>
                    <div>
                        <span className="font-semibold text-teal-300">UPGRADE:</span> ₹{t.paidPrice} for {t.paidValidityDays} days
                    </div>
                </div>

                <div className="mt-4">
                    <div className="text-sm uppercase tracking-wide mb-1">
                        Progress: {p.ordersCount || 0} / {t.unlockOrders}
                    </div>
                    <div className={`h-2 mt-1 bg-gray-700 rounded-full overflow-hidden ${styles.progressBar}`}>
                        <div
                            style={{
                                width: `${Math.min(100, ((p.ordersCount || 0) / t.unlockOrders) * 100)}%`,
                                background: t.badgeColor || '#888'
                            }}
                            className="h-full rounded-full progress-fill"
                        />
                    </div>
                    {eligible && <div className="mt-2 text-[#00e20f] font-semibold">Eligible for free unlock!</div>}
                </div>

                <div className="mt-4 flex items-center">
                    <button
                        className={`text-white px-6 py-2 rounded-lg ${styles.ctaButton}`}
                        onClick={() => buyTier(t._id)}
                        disabled={isActive}
                    >
                        {isActive ? 'Active' : 'Activate Protocol!'}
                    </button>
                    {isActive && (
                        <span className="ml-4 text-teal-500 text-sm">
                            Expires: {new Date(userVip.expiresAt).toLocaleDateString()}
                        </span>
                    )}
                </div>
            </div>

            {/* Right-side Character Image */}
            <div className="absolute right-[-20px] top-0 h-full w-1/3 z-20 flex items-center">
                <img
                    src={images[index % images.length]}
                    alt="Character"
                    className={`object-cover object-center h-full w-full ${styles.characterImage}`}
                />
            </div>
        </div>
    );
};

export default VipCard;